// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {CostumerSelector, getCostumer, insertCostumer, updateCostumer,} from "./CostumerSlice";

import {Colors} from "../../../assets/Colors";

const CostumerPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [showModalCreateAccount, setModalCreateAccount] = useState(false);
    const [showModalResetAccount, setModalResetAccount] = useState(false);

    const Costumer = useSelector(CostumerSelector);

    useEffect(() => {
        dispatch(
            getCostumer({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && Costumer.isGetSuccess && !Costumer.isGetFetching) {
            let calc = Costumer?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Costumer.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (
            search === "" &&
            Costumer.isGetSuccess &&
            !Costumer.isGetFetching
        ) {
            let calc = Costumer?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Costumer.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !Costumer?.isGetFetching &&
            Costumer.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = Costumer?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Costumer.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getCostumer({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (Costumer.isGetSuccess) {
                alertService.success(Costumer.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getCostumer({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (Costumer.isUpdateSuccess) {
                alertService.success(Costumer.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateCostumer({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetCostumer(params) {
    //   return dispatch(getCostumer(params));
    // }

    function handleInsertCostumer(param) {
        setInsertFetch(true);
        const params = {
            DetailAccountID: param.dropdownDetailAccountValue,
            NamaCust: param.inputOneValue,
            Kontak: param.inputTwoValue,
            Jabatan: param.inputThreeValue,
            NoTlpn: param.inputFourValue,
            Alamat: param.inputFiveValue,
            NPWP: param.inputSixValue,
            AlamatNPWP: param.inputSevenValue,
            Catatan: param.inputEightValue,
        };

        dispatch(insertCostumer(params));
    }

    function handleUpdateCostumer(param) {
        setUpdateFetch(true);

        const params = {
            DetailAccountID: param.dropdownDetailAccountValue,
            NamaCust: param.inputOneValue,
            Kontak: param.inputTwoValue,
            Jabatan: param.inputThreeValue,
            NoTlpn: param.inputFourValue,
            Alamat: param.inputFiveValue,
            NPWP: param.inputSixValue,
            AlamatNPWP: param.inputSevenValue,
            Catatan: param.inputEightValue,
            CostumerID: currentData.CostumerID,
            status: param.status,
        };
        dispatch(updateCostumer(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getCostumer(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getCostumer(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = Costumer.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? Costumer.count : newCount,
            search: search,
        };
        dispatch(getCostumer(params));

        setPage(1);
        setCount(newCount === "-1" ? Costumer.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
        setModalCreateAccount(status.showModalCreateAccount);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <>
                <div className="md:ml-64">
                    <div
                        style={{background: Colors.primary}}
                        className="pt-14 pb-16 px-3 md:px-8 h-auto"
                    >
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                        </div>
                    </div>

                    <div className="px-3 md:px-8 h-auto -mt-32">
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 px-4">
                                <TableCard
                                    backButton={true}
                                    backUrl={"master"}
                                    handleSearch={handleSearch}
                                    searchPlaceholder="Costumer"
                                    updatePage={handleUpdatePage}
                                    updateCount={handleUpdateCount}
                                    currentData={handleCurrentData}
                                    currentPage={page}
                                    maxPage={maxPage}
                                    tableTitle="Master Costumer"
                                    tableData={Costumer.data}
                                    colOneTitle="ID"
                                    colOneData="CustID"
                                    colTwoTitle="Nama Costumer"
                                    colTwoData="NamaCust"
                                    status="Status"
                                    colThreeTitle="Kontak"
                                    colThreeData="Kontak"
                                    fetching={Costumer.isGetFetching}
                                    modal={handleModal}
                                    editEnabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Costumer"
                        dropdownDetailAccount={true}
                        inputOneTitle="Nama Klien"
                        inputTwoTitle="Kontak"
                        inputThreeTitle="Jabatan"
                        inputFourTitle="Nomor Telepon"
                        inputFourType="number"
                        inputFiveTitle="Alamat"
                        inputSixTitle="NPWP"
                        inputSevenTitle="Alamat NPWP"
                        inputEightTitle="Catatan"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertCostumer}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.CostumerID}
                        modal={handleModal}
                        modalTitle="Ubah Costumer"
                        dropdownDetailAccount={true}
                        dropdownDetailAccountValue={currentData.DetailAccountID}
                        inputOneTitle="Nama Costumer"
                        inputOneValue={currentData.NamaCust}
                        inputTwoTitle="Kontak"
                        inputTwoValue={currentData.Kontak}
                        inputThreeTitle="Jabatan"
                        inputThreeValue={currentData.Jabatan}
                        inputFourTitle="Nomor Telepon"
                        inputFourValue={currentData.NoTlpn}
                        inputFourType="number"
                        inputFiveTitle="Alamat"
                        inputFiveValue={currentData.Alamat}
                        inputSixTitle="NPWP"
                        inputSixValue={currentData.NPWP}
                        inputSevenTitle="Alamat NPWP"
                        inputSevenValue={currentData.AlamatNPWP}
                        inputEightTitle="Catatan"
                        inputEightValue={currentData.Catatan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateCostumer}
                    />
                )}
            </>
        );
    }
};

export default CostumerPage;
